export default __webpack_public_path__ + "static/media/error404.c0aaf976.png";